import './Footer.css'
import { Link } from 'react-router-dom';

const Footer = () => {
    return (
        <footer className="footer">
            <div className="footer-container">
                <div className="footer-column">
                    <Link to="/about-us" className="footer-link">About Us</Link>
                    <Link to="/careers" className="footer-link">Careers</Link>
                    <Link to="/blog" className="footer-link">Blog</Link>
                </div>
                <div className="footer-column">
                    <Link to="/contact" className="footer-link">Contact</Link>
                    <Link to="/nutrition" className="footer-link">Nutrition</Link>
                    <Link to="/terms-privacy" className="footer-link">Terms & Privacy</Link>
                </div>
            </div>
            <div className="footer-bottom">
                <p>&copy; 2025 RENZ LLC. All rights reserved.</p>
            </div>
        </footer>
    )
}

export default Footer;